import { cn } from '../lib/cn.js';

/**
 * A loading spinner.
 *
 * Inherits `currentColor`, so it is correct inside a primary button, a ghost
 * button and a danger banner without any of them telling it what colour to be.
 *
 * Silent to screen readers. The thing that is loading announces itself — a
 * button sets `aria-busy`, a region sets `aria-live` — and a spinner that also
 * announces produces "Loading, loading" on every submit.
 */
export function Spinner({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('animate-spin', className)}
    >
      {/* The faint full ring gives the moving arc something to travel along;
          without it the arc reads as a fragment rather than as rotation. */}
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.25" opacity="0.2" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
      />
    </svg>
  );
}
